import config from "../config"
import { Api } from "./api"
import { MockApi } from "./mock-api"

export * from "./api-result"
export * from "./api-res-type"
export * from "./api-parameters-type"
export * from "./api-error-code-type"


const api = config.REACT_APP_USE_MOCK_API ? MockApi : new Api()

export default api

